import React, { useCallback } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch } from 'react-redux';

import { Button } from 'src/component/ds/ui/button';
import { pushHistory } from 'src/module/navigation/action';
import { useTranslation } from 'src/i18n';

const DEVICES_PATH = '/devices';

/**
 * Fills the Alarm Volume card when the facility has no units to tile.
 *
 * @returns {JSX.Element} the empty state
 */
export default function NoUnits () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const openDevices = useCallback(() => dispatch(pushHistory(DEVICES_PATH)), [dispatch]);

  return (
    <div
      className='ds-flex ds-h-[186px] ds-flex-col ds-items-center ds-justify-center ds-gap-1.5 ds-text-center'
      data-testid='alarm-volume-no-units'
    >
      <p className='ds-text-ds-base ds-font-medium ds-text-foreground'>{t('dashboard.alarmVolumeNoUnits')}</p>
      <p className='ds-text-ds-sm ds-text-muted-foreground'>{t('dashboard.alarmVolumeNoUnitsHelp')}</p>
      <Button className='ds-mt-1'onClick={openDevices} data-testid='alarm-volume-no-units-cta'>
        <span>{t('dashboard.alarmVolumeGoToDevices')}</span>
        <ChevronRightIcon fontSize='inherit' aria-hidden='true' />
      </Button>
    </div>
  );
}
